import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { getEcommerceStoresRpc } from '../../__generated__/chirp/com/hubspot/website/interactive/rpc/WebsiteInteractiveStoresService';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export function fetchStores() {
  return rpcClient.call(getEcommerceStoresRpc, {});
}
export function fetchConnections({
  storeAccountId,
  appId
}) {
  return http.get(`sync-bridge/v3/accounts/${storeAccountId}/connections`, {
    query: {
      appId
    }
  });
}
export function fetchObjects(query) {
  return http.get(`sync-health/v1/record/list`, {
    query: Object.assign({}, query, {
      status: 'IN_SYNC'
    })
  });
}